// src/components/Dash.js
import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from '../components/hooks/useAuth';
import ProfileDropdown from './profile/ProfileDropdown';
import { 
    Home,
    Map,
    BookOpen,
    Book,
    Contact,
    User,
    Plus
} from "lucide-react";
import './Dash.css';
import looogo from './images/CompanyLogo.svg';


const Dash = () => {
    const { isAuthenticated, user } = useAuth();
    const [isNavVisible, setIsNavVisible] = useState(true);
    const timerRef = useRef(null);
    const navigate = useNavigate();

    const showNav = () => {
        setIsNavVisible(true);
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => setIsNavVisible(false), 30000);
    };

    useEffect(() => {
        const handleMouseMove = (event) => {
            if (event.clientX <= 50) {
                showNav();
            }
        };

        document.addEventListener('mousemove', handleMouseMove);
        showNav();

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, []);

    return (
        <>
            <div className="dashboard-layout">
                <div className="top-bar">
                    <Link to="/">
                        <img src={looogo} className="looogo" alt="Logo" />
                    </Link>

                    {isAuthenticated && (
                        <ProfileDropdown 
                            user={user} 
                            onNavigate={navigate}
                        />
                    )}
                </div>

                {!isNavVisible && (
                    <div className="navbar-indicator" onMouseEnter={showNav}></div>
                )}

                <div 
                    className={`nav-container ${isNavVisible ? '' : 'hidden'}`} 
                    onMouseEnter={showNav}
                >
                    <ul className="list">
                        <li id="home">
                            <Link to="/" className="nav-icon">
                                <Home size={20} />
                                <span className="tooltip">Home</span>
                            </Link>
                        </li>
                        <li id="roadmap">
                            <Link to="/roadmap" className="nav-icon">
                                <Map size={20} />
                                <span className="tooltip">Roadmap</span>
                            </Link>
                        </li>
                        <li id="insights">
                            <Link to="/blog" className="nav-icon">
                                <BookOpen size={20} />
                                <span className="tooltip">Blogs</span>
                            </Link>
                        </li>
                        <li id="resources">
                            <Link to="/learning" className="nav-icon">
                                <Book size={20} />
                                <span className="tooltip">Resources</span>
                            </Link>
                        </li>
                        <li id="contact">
                            <Link to="/contact" className="nav-icon">
                                <Contact size={20} />
                                <span className="tooltip">Contact</span>
                            </Link>
                        </li>
                        {!isAuthenticated && (
                            <li id="login">
                                <Link to="/login" className="nav-icon">
                                    <User size={20} />
                                    <span className="tooltip">Login</span>
                                </Link>
                            </li>
                        )}
                        {isAuthenticated && user?.role === 'admin' && (
                            <li id="admin">
                                <Link to="/admin/add-resource" className="nav-icon">
                                    <Plus size={20} />
                                    <span className="tooltip">Add Resource</span>
                                </Link>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default Dash;